export { ActorTypeEnum, } from '@novu/shared';
export var ScreensEnum;
(function (ScreensEnum) {
    ScreensEnum["NOTIFICATIONS"] = "notifications";
    ScreensEnum["SETTINGS"] = "settings";
})(ScreensEnum || (ScreensEnum = {}));
